export class KeypadControlsViewEvents {
    public static readonly AUTOPLAY_CLICKED: symbol = Symbol('__AUTOPLAY_CLICKED__');
    public static readonly TURBO_CHECKBOX_CLICKED: symbol = Symbol('__TURBO_CHECKBOX_CLICKED__');

    public static readonly BET_INC_CLICKED: symbol = Symbol('__BET_INC_CLICKED__');
    public static readonly BET_DEC_CLICKED: symbol = Symbol('__BET_DEC_CLICKED__');

    public static readonly INFO_CLICKED: symbol = Symbol('INFO_CLICKED');
}